import { createSlice } from '@reduxjs/toolkit';

const adminInfoSlice = createSlice({
  name: 'adminInfo',
  initialState: { adminVo: null, config: false, isFinish: false, isApproval: false },
  reducers: {
    getAdminInfo: () => {},
    getAdminInfoSuccess: (state, { payload }) => {
      state.adminVo = payload.memberVO;
      state.adminVo.locale = payload.memberVO.prefLangCd;
    },
    getAdminInfoFail: state => {
      state.adminVo = true;
    },
    updatePortalConfig: () => {},
    updatePortalConfigSuccess: state => {
      state.config = true;
    },
    updatePortalConfigFail: (state, { payload }) => {
      state.config = false;
    },
    updateFinishPortalConfig: () => {},
    updateFinishPortalConfigSuccess: (state, { payload }) => {
      state.isFinish = payload;
    },
    updateFinishPortalConfigFail: state => {
      state.isFinish = false;
    },
    createApprovalComp: () => {},
    createApprovalCompSuccess: (state, { payload }) => {
      state.isApproval = payload;
    },
  },
});

export const {
  getAdminInfo,
  getAdminInfoSuccess,
  getAdminInfoFail,
  updatePortalConfig,
  updatePortalConfigSuccess,
  updatePortalConfigFail,
  updateFinishPortalConfig,
  updateFinishPortalConfigSuccess,
  updateFinishPortalConfigFail,
  createApprovalComp,
  createApprovalCompSuccess,
} = adminInfoSlice.actions;
export default adminInfoSlice.reducer;
